import React from 'react';

import { IVerticalBarChart } from '../../../../interfaces/charts';
import './VerticalBarChart.scss';

const Y_AXIS_TICKS = [100, 75, 50, 25, 0];

const toPercentage = (value: number): number => Math.min(Math.max(value, 0), 1) * 100;

const VerticalBarChart = ({ data }: IVerticalBarChart) => {
  return (
    <div className="vertical-bar-chart">
      <div className="chart-y-axis">
        {Y_AXIS_TICKS.map((tick) => (
          <span key={tick} className="y-axis-label">{`${tick}%`}</span>
        ))}
      </div>
      <div className="chart-columns">
        {data.map((item) => {
          const percentage = toPercentage(item.value);
          return (
            <div className="chart-column" key={item.key}>
              <div className="chart-plot">
                <div className="chart-bar" aria-hidden="true" style={{ height: `${percentage}%` }} />
              </div>
              <div className="chart-label">
                <span className="chart-label-text">{item.label}</span>
                <span className="chart-label-value">{`${Math.round(percentage)}%`}</span>
                <span className="chart-label-icon">{item.icon && <img src={item.icon} alt="" />}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VerticalBarChart;
